/** Turn an object key like `inputTokens` or `_prompt_tokens` into "Input tokens". */
export function humanizeKey(key: string): string {
  const cleaned = key
    .replace(/^_+/, "")
    .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
    .replace(/[_-]+/g, " ")
    .trim()
    .toLowerCase();
  if (!cleaned) return key;
  return cleaned.charAt(0).toUpperCase() + cleaned.slice(1);
}
